import Invoice from './Invoice';
import Uuid from '../../../models/Uuid'; // Adjust the import path as necessary

export default class File {
    id: Uuid
    loading: boolean
    file_name: string
    file_type: string
    file_size: number
    file_last_modified: string
    invoices: Invoice[]

    constructor(
        id: Uuid,
        file_name: string,
        file_type: string,
        file_size: number,
        file_last_modified: string
    ) {
        this.id = id
        this.loading = true
        this.file_name = file_name
        this.file_type = file_type
        this.file_size = file_size
        this.file_last_modified = file_last_modified
        this.invoices = []
    }
    
    update_invoice(invoice: Invoice): void {
        const invoice_index = this.invoices.findIndex(
            (tmp_invoice) => tmp_invoice.id.get() === invoice.id.get()
        );
        this.invoices.splice(invoice_index, 1, invoice);
    }
}
